export function uniqBy<T>(
    a: T[],
    key: (x: T) => T[keyof T] | number | string
): T[] {
    const seen = {};
    return a.filter(function (item) {
        if (item) {
            const k = key(item) && key(item).toString();
            return seen.hasOwnProperty(k) ? false : (seen[k] = true);
        } else {
            return false;
        }
    });
}

export function uniqFilter(value, index, self) {
    return self.indexOf(value) === index;
}
